import { CommonTypes } from '@store/types/commonTypes'

export const commonInitial: CommonTypes = {
  isClickChangePassword: false,
  defaultListPermission: [],
  availablePermissions: 0
}
